/**
 * @generated SignedSource<<9387a57e2327cb1e2e2ae136459081bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorListQuery$data = {
  readonly authors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Author";
        readonly entityId: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
      };
    }>;
  };
  readonly " $fragmentType": "authorListQuery";
};
export type authorListQuery$key = {
  readonly " $data"?: authorListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorListQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "authors"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "applicationId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "name"
    },
    {
      "kind": "RootArgument",
      "name": "nameOperator"
    },
    {
      "kind": "RootArgument",
      "name": "published"
    },
    {
      "kind": "RootArgument",
      "name": "types"
    },
    {
      "kind": "RootArgument",
      "name": "typesOperator"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./authorListPaginationQuery.graphql')
    }
  },
  "name": "authorListQuery",
  "selections": [
    {
      "alias": "authors",
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "operator",
                  "variableName": "nameOperator"
                },
                {
                  "kind": "Variable",
                  "name": "value",
                  "variableName": "name"
                }
              ],
              "kind": "ObjectValue",
              "name": "name"
            },
            {
              "kind": "Variable",
              "name": "published",
              "variableName": "published"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "operator",
                  "variableName": "typesOperator"
                },
                {
                  "kind": "Variable",
                  "name": "value",
                  "variableName": "types"
                }
              ],
              "kind": "ObjectValue",
              "name": "types"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASC",
            "field": "NAME"
          }
        }
      ],
      "concreteType": "AuthorConnection",
      "kind": "LinkedField",
      "name": "__authorListQuery__authors_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Author",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "entityLink"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "c4247374505077f3ee21b83625ff1ab7";

export default node;
